const Footer = () => {
  return (
    <footer className="bg-primary-900 text-slate-300 py-12 mt-12">
      <div className="container mx-auto px-4 grid md:grid-cols-3 gap-8 text-sm">
        <div>
          <h4 className="text-white font-bold text-lg mb-4">Universidad Nacional de Lomas de Zamora</h4>
          <p className="mb-2">Juan XXIII y Ruta Prov. Nro.4</p>
          <p>Lomas de Zamora, Buenos Aires</p>
        </div>

        <div>
          <h4 className="text-white font-bold text-lg mb-4">Contacto</h4>
          <p className="mb-2">Tel: 11 7091-UNLZ(8659)</p>
          <p>Email: <a href="mailto:info@unlz.edu.ar" className="text-accent-500 hover:underline">info@unlz.edu.ar</a></p>
        </div>

        <div>
          <h4 className="text-white font-bold text-lg mb-4">Enlaces</h4>
          <p className="mb-2">
            Sitio Web: <a href="https://www.unlz.edu.ar" target="_blank" rel="noopener noreferrer" className="text-accent-500 hover:underline">www.unlz.edu.ar</a>
          </p>
          <div className="flex space-x-4 mt-4">
            <a href="https://instagram.com/unlzoficial" target="_blank" rel="noopener noreferrer" className="text-white hover:text-pink-500 transition-colors">
              Instagram
            </a>
            <span className="text-slate-600">|</span>
            <a href="https://x.com/unlzoficial" target="_blank" rel="noopener noreferrer" className="text-white hover:text-sky-400 transition-colors">
              X (Twitter)
            </a>
          </div>
        </div>
      </div>
      <div className="text-center mt-12 pt-8 border-t border-slate-800 text-slate-500 text-xs">
        &copy; {new Date().getFullYear()} UNLZ. Todos los derechos reservados.
      </div>
    </footer>
  );
};
export default Footer;